import { render, staticRenderFns } from "./coach-certificate.vue?vue&type=template&id=e3fc1dc0&scoped=true&"
import script from "./coach-certificate.vue?vue&type=script&lang=js&"
export * from "./coach-certificate.vue?vue&type=script&lang=js&"
import style0 from "./coach-certificate.vue?vue&type=style&index=0&id=e3fc1dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fc1dc0",
  null
  
)

export default component.exports